module.exports = __webpack_public_path__ + "img/home_banner3.7ee91a9e.jpg";